var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9644 12.1908C21.9644 11.355 21.8966 10.7451 21.7498 10.1127H12.2061V13.885H17.808C17.6951 14.8224 17.0852 16.2342 15.7299 17.1829L15.7109 17.3092L18.7284 19.6469L18.9375 19.6677C20.8575 17.8945 21.9644 15.2855 21.9644 12.1908Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.206 22.13C14.9505 22.13 17.2545 21.2264 18.9374 19.6678L15.7298 17.183C14.8714 17.7816 13.7194 18.1994 12.206 18.1994C9.51792 18.1994 7.23647 16.4263 6.42319 13.9754L6.30398 13.9855L3.16628 16.4138L3.12524 16.5279C4.7968 19.8484 8.23031 22.13 12.206 22.13Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4232 13.9754C6.20861 13.3429 6.08442 12.6652 6.08442 11.965C6.08442 11.2647 6.20861 10.587 6.41191 9.95455L6.40623 9.81985L3.2292 7.35254L3.12525 7.40198C2.43632 8.77992 2.04102 10.3273 2.04102 11.965C2.04102 13.6026 2.43632 15.1499 3.12525 16.5279L6.4232 13.9754Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.206 5.73041C14.1147 5.73041 15.4022 6.5549 16.1364 7.24391L19.0052 4.44288C17.2433 2.80519 14.9505 1.79999 12.206 1.79999C8.2303 1.79999 4.7968 4.08144 3.12524 7.40197L6.4119 9.95454C7.23647 7.50366 9.51792 5.73041 12.206 5.73041Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.95e7a06f2aabf94f47b8904a2f15c8ac.svg";
export { ForwardRef as ReactComponent };